import InquiryDetailContainer from './InquiryDetailContainer';
export default InquiryDetailContainer;
